import { Typography } from '@cobliteam/ui/components';

import Icon from '@cobliteam/ui/icons';
import styles from './styles';

interface AppCodeWrapperProps {
  driverCode?: string | null;
}

const AppCodeWrapper = ({ driverCode }: AppCodeWrapperProps) => (
  <div className={styles.driverCodeCell}>
    <Icon name='smartphone' className={styles.smartphoneIconWithCustomColor} />
    <Typography variant='text-md' color='secondary'>
      {driverCode}
    </Typography>
  </div>
);

export default AppCodeWrapper;
